'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getTransformStyles = {};

exports.__exports = getTransformStyles;
